// Dismiss dialog when user clicks on backdrop.

export default function dialogDismiss() {
  document.addEventListener("click", event => {
    if (event.target.tagName === "DIALOG") {
      event.target.close();
    }
  })
}